module.exports = __webpack_public_path__ + "static/media/att-socio-factura.0785dea0.svg";